export const JSON_ONE8NW = {

    "ag_id":"paygate",
    "me_id":"202205240004",
    "ag_ref":"1010176361036299506",
    "refund_amount":"100",
    "currency":"AED",
    "txn_date":"2021-06-30",
    "txn_time":"15:31:42",
    "refund_ref":"1901",
    "pg_ref":"PG_1010176361036299506",
    "status":"PARTIAL REFUND",
    "res_code":"00000",
    "res_message":"Refund",
    "error_details":"null"

}